<facility-google-map-new #googlemap></facility-google-map-new>